import { useSyncExternalStore } from "react";
import { dismissToast, subscribeToasts, toastSnapshot } from "../toast";

export function Toasts() {
  const toasts = useSyncExternalStore(subscribeToasts, toastSnapshot);
  return (
    /* Every error this app raises arrives here and nowhere else, so without a
       live region they are all silent to a screen reader. `polite` rather than
       `assertive`: these interrupt at the end of a sentence, not mid-word. */
    <div id="toasts" role="status" aria-live="polite" aria-atomic="false">
      {toasts.map((item) => (
        <div key={item.id} className={`toast ${item.kind}`.trim()}>
          <span className="toast-text">{item.text}</span>
          {item.action && (
            <button
              className="link"
              onClick={() => {
                item.action?.run();
                dismissToast(item.id);
              }}
            >
              {item.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
